import { styled } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import { CollapsableSection, Columns, Flex, FormLabel, FormSelect, Input, Loading, Option } from 'lqx-react';
import * as React from 'react';
import { useCallback, useRef } from 'react';
import NumberFormat from 'react-number-format';
import { getCompanies } from '../../api/company';
import { getSuppliersAsCommonParticipants } from '../../api/companyParticipant';
import { Component } from '../../api/component';
import { ManualPurchaseOrder } from '../../api/manualPurchaseOrder';
import { PurchaseOrder } from '../../api/purchaseOrder';
import { NumberWithDecimalEditor, NumberWithoutDecimalEditor, SelectUnitEditor } from '../../components/ag-grid-cell-formating';
import { AgGridReactContainer, StyledAddCircle, StyledRemoveCircle } from '../../components/ag-grid-styles';
import { AssetColumn, AssetLabel, numberInputStyles } from "../../components/number-input";
import { DigiSelectAsync } from '../../components/select-async';
import { asTimelessLinkedDate, DigiDateInput, ErrorHighligter } from '../../shared';
import { PurchaseOrderComponentTableColumns } from './pruchase-order-component-table-columns';

export const PurchaseOrderForm = ({ purchaseOrder }: { purchaseOrder: PurchaseOrder | ManualPurchaseOrder }) => {
    const classes = numberInputStyles();

    const defaultColDef = {
        editable: true,
        filter: false,
        resizable: true,
        minWidth: 150
    };
    const gridApi = useRef(null);
    const onGridReady = (params: { api: any; }) => {
        gridApi.current = params.api;
    };

    const onAddRow = useCallback(() => {
        purchaseOrder.components.unshift(new Component());
        gridApi.current!.setRowData(purchaseOrder.components.models);
        gridApi.current!.setFocusedCell(0, 'number');
        gridApi.current!.startEditingCell({ rowIndex: 0, colKey: 'number' });
    }, [])

    const onRemoveRow = useCallback(() => {
        const selectedData = gridApi.current!.getSelectedRows();
        purchaseOrder.components.remove(selectedData);
        gridApi.current.updateRowData({ remove: selectedData });
    }, []);

    return true ? <>
        <Columns>
            <AssetColumn>
                <AssetLabel>Supplier *</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['supplier']}>
                    <DigiSelectAsync
                        data-qa-id={"supplier"}
                        getItems={getSuppliersAsCommonParticipants}
                        $value={purchaseOrder.$.supplier}
                    />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>Supplier External ID</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['supplierExternalID']}>
                    <Input data-qa-id="supplier external id" $value={purchaseOrder.supplier.$.externalId} />
                </ErrorHighligter>
            </AssetColumn>
            <CollapsableSection title="Address " noMargins>
                <Columns>
                    <AssetColumn>
                        <AssetLabel>Line 1</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['line1']}>
                            <Input data-qa-id="line 1" $value={purchaseOrder.supplier.address.$.line1} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Line 2</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['line2']}>
                            <Input data-qa-id="line 2" $value={purchaseOrder.supplier.address.$.line2} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>City</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['city']}>
                            <Input data-qa-id="city" $value={purchaseOrder.supplier.address.$.city} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>State Province</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['stateProvince']}>
                            <Input data-qa-id="stateProvince" $value={purchaseOrder.supplier.address.$.stateProvince} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Postal Code</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['postalCode']}>
                            <Input data-qa-id="postalCode" $value={purchaseOrder.supplier.address.$.postalCode} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Country Code</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['countryCode']}>
                            <Input data-qa-id="countryCode" $value={purchaseOrder.supplier.address.$.countryCode} />
                        </ErrorHighligter>
                    </AssetColumn>
                </Columns>
            </CollapsableSection>
            <AssetColumn>
                <AssetLabel>Customer *</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['customer']}>
                    <DigiSelectAsync
                        data-qa-id={"customer"}
                        getItems={getCompanies}
                        $value={purchaseOrder.$.customer}
                    />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>Customer External ID</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['customerExternalID']}>
                    <Input data-qa-id="customer external id" $value={purchaseOrder.customer.$.externalId} />
                </ErrorHighligter>
            </AssetColumn>
            <CollapsableSection title="Address " noMargins>
                <Columns>
                    <AssetColumn>
                        <AssetLabel>Line 1</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['line1']}>
                            <Input data-qa-id="line 1" $value={purchaseOrder.customer.address.$.line1} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Line 2</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['line2']}>
                            <Input data-qa-id="line 2" $value={purchaseOrder.customer.address.$.line2} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>City</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['city']}>
                            <Input data-qa-id="city" $value={purchaseOrder.customer.address.$.city} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>State Province</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['stateProvince']}>
                            <Input data-qa-id="stateProvince" $value={purchaseOrder.customer.address.$.stateProvince} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Postal Code</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['postalCode']}>
                            <Input data-qa-id="postalCode" $value={purchaseOrder.customer.address.$.postalCode} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Country Code</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['countryCode']}>
                            <Input data-qa-id="countryCode" $value={purchaseOrder.customer.address.$.countryCode} />
                        </ErrorHighligter>
                    </AssetColumn>
                </Columns>
            </CollapsableSection>
            <AssetColumn>
                <AssetLabel>Purchase Order# *</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['number']}>
                    <Input data-qa-id="credit note number" $value={purchaseOrder.$.number} />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>Amount *</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['amount']}>
                    <NumberFormat data-qa-id="amount" value={purchaseOrder.amount} className={classes.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; purchaseOrder.$.amount.set(floatValue) }} />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>Currency *</AssetLabel>
                <ErrorHighligter error={purchaseOrder.errors['currency']}>
                    <FormSelect data-qa-id="currency dropdown" label="" $value={purchaseOrder.$.currency} >
                        <Option value="USD">USD</Option>
                        <Option value="SGD">SGD</Option>
                        <Option value="GBP">GBP</Option>
                        <Option value="CAD">CAD</Option>
                        <Option value="EUR">EUR</Option>
                        <Option value="AUD">AUD</Option>
                        <Option value="MXN">MXN</Option>
                    </FormSelect>
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>PO Date *</AssetLabel>
                <ErrorHighligterStyled error={purchaseOrder.errors['poDate']}>
                    <DigiDateWrapper>
                        <DigiDateInput data-qa-id="poDate" date $value={asTimelessLinkedDate(purchaseOrder.$.poDate)} />
                    </DigiDateWrapper>
                </ErrorHighligterStyled>
            </AssetColumn>
            <AssetColumn>
                <AssetLabel>Post Date *</AssetLabel>
                <ErrorHighligterStyled error={purchaseOrder.errors['postDate']}>
                    <DigiDateWrapper>
                        <DigiDateInput data-qa-id="postDate" date $value={asTimelessLinkedDate(purchaseOrder.$.postDate)} />
                    </DigiDateWrapper>
                </ErrorHighligterStyled>
            </AssetColumn>
            <CollapsableSection title="ADDITIONAL FIELDS  " noMargins>
                <Columns>
                    <AssetColumn>
                        <AssetLabel>Sales Order# *</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['saleOrderNumber']}>
                            <Input data-qa-id="saleOrderNumber" $value={purchaseOrder.details.saleOrder.$.number} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Quote# *</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['quoteNumber']}>
                            <Input data-qa-id="quote Number" $value={purchaseOrder.details.quote.$.number} />
                        </ErrorHighligter>
                    </AssetColumn>
                    <AssetColumn>
                        <AssetLabel>Bill To *</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['billTo']}>
                            <DigiSelectAsync
                                data-qa-id={"billTo"}
                                getItems={getCompanies}
                                $value={purchaseOrder.$.billTo}
                            />
                        </ErrorHighligter>
                    </AssetColumn>
                    <CollapsableSection title="Address " noMargins>
                        <Columns>
                            <AssetColumn>
                                <AssetLabel>Line 1</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['line1']}>
                                    <Input data-qa-id="line 1" $value={purchaseOrder.billTo.address.$.line1} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Line 2</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['line2']}>
                                    <Input data-qa-id="line 2" $value={purchaseOrder.billTo.address.$.line2} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>City</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['city']}>
                                    <Input data-qa-id="city" $value={purchaseOrder.billTo.address.$.city} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>State Province</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['stateProvince']}>
                                    <Input data-qa-id="stateProvince" $value={purchaseOrder.billTo.address.$.stateProvince} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Postal Code</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['postalCode']}>
                                    <Input data-qa-id="postalCode" $value={purchaseOrder.billTo.address.$.postalCode} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Country Code</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['countryCode']}>
                                    <Input data-qa-id="countryCode" $value={purchaseOrder.billTo.address.$.countryCode} />
                                </ErrorHighligter>
                            </AssetColumn>
                        </Columns>
                    </CollapsableSection>
                    <AssetColumn>
                        <AssetLabel>Ship To *</AssetLabel>
                        <ErrorHighligter error={purchaseOrder.errors['shipTo']}>
                            <DigiSelectAsync
                                data-qa-id={"shipTo"}
                                getItems={getCompanies}
                                $value={purchaseOrder.$.shipTo}
                            />
                        </ErrorHighligter>
                    </AssetColumn>
                    <CollapsableSection title="Address " noMargins>
                        <Columns>
                            <AssetColumn>
                                <AssetLabel>Line 1</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['line1']}>
                                    <Input data-qa-id="line 1" $value={purchaseOrder.shipTo.address.$.line1} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Line 2</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['line2']}>
                                    <Input data-qa-id="line 2" $value={purchaseOrder.shipTo.address.$.line2} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>City</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['city']}>
                                    <Input data-qa-id="city" $value={purchaseOrder.shipTo.address.$.city} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>State Province</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['stateProvince']}>
                                    <Input data-qa-id="stateProvince" $value={purchaseOrder.shipTo.address.$.stateProvince} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Postal Code</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['postalCode']}>
                                    <Input data-qa-id="postalCode" $value={purchaseOrder.shipTo.address.$.postalCode} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Country Code</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['countryCode']}>
                                    <Input data-qa-id="countryCode" $value={purchaseOrder.shipTo.address.$.countryCode} />
                                </ErrorHighligter>
                            </AssetColumn>
                        </Columns>
                    </CollapsableSection>

                    <CollapsableSection title="SHIPPING  " noMargins>
                        <Columns>
                            <AssetColumn>
                                <AssetLabel>Account</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['account']}>
                                    <Input data-qa-id="account" $value={purchaseOrder.shipping.$.account} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Carrier</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['carrier']}>
                                    <Input data-qa-id="carrier" $value={purchaseOrder.shipping.$.carrier} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Instruction</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['instruction']}>
                                    <Input data-qa-id="instruction" $value={purchaseOrder.shipping.$.instruction} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Method</AssetLabel>
                                <ErrorHighligter error={purchaseOrder.errors['method']}>
                                    <Input data-qa-id="method" $value={purchaseOrder.shipping.$.method} />
                                </ErrorHighligter>
                            </AssetColumn>
                            <AssetColumn>
                                <AssetLabel>Planned Delivery Date</AssetLabel>
                                <ErrorHighligterStyled error={purchaseOrder.errors['planDeliveryDate']}>
                                    <DigiDateWrapper>
                                        <DigiDateInput data-qa-id="planDeliveryDate" date $value={asTimelessLinkedDate(purchaseOrder.shipping.$.planDeliveryDate)} />
                                    </DigiDateWrapper>
                                </ErrorHighligterStyled>
                            </AssetColumn>
                        </Columns>
                    </CollapsableSection>


                </Columns>
            </CollapsableSection>
        </Columns>

        <CollapsableSection title="Components" noMargins notExpanded={true}>
            <Flex row>
                <StyledAddCircle onClick={onAddRow}></StyledAddCircle>
                <FormLabel>Add New Line</FormLabel>
                <StyledRemoveCircle onClick={onRemoveRow}></StyledRemoveCircle>
                <FormLabel>Remove Line</FormLabel>
            </Flex>
            <AgGridReactContainer className={`ag-theme-balham`}>
                <AgGridReact
                    onGridReady={onGridReady}
                    columnDefs={PurchaseOrderComponentTableColumns}
                    frameworkComponents={{ NumberWithoutDecimalEditor, NumberWithDecimalEditor, SelectUnitEditor }}
                    rowSelection='multiple'
                    defaultColDef={defaultColDef}
                    overlayNoRowsTemplate={"No Items"}
                    rowData={purchaseOrder.components as any}>
                </AgGridReact>
            </AgGridReactContainer>
        </CollapsableSection>
        <br />
    </> : <Loading />;
};

const DigiDateWrapper = styled('div')({
    '& .react-datepicker-wrapper': {
        width: '100%',
    },
    '& input': {
        minWidth: '200px'
    }
})

const ErrorHighligterStyled = styled(ErrorHighligter)({
    boxSizing: 'border-box',
    width: '100%'
})
